jQuery(function ($) {
  trusted_slider();
  technology_stack();
});

// trusted_slider js
function trusted_slider() {
  jQuery(".trusted_slider").owlCarousel({
    loop: true,
    autoplay: true,
    margin: 0,
    nav: false,
    autoplayTimeout: 3000,
    slideSpeed: 2000,
    dots: false,
    responsive: {
      0: {
        items: 2,
      },
      700: {
        items: 3,
      },
      1100: {
        items: 4,
      },
      1366: {
        items: 5,
      },
    },
  });
}

// Technology Stack section js start here
function technology_stack() {
  jQuery(".technology_stack_tabs li:first-child").addClass("current");
  jQuery(".technology_tab-content:first").addClass("current");
  jQuery(".technology_stack_tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");
    jQuery(".technology_stack_tabs li").removeClass("current");
    jQuery(".technology_tab-content").removeClass("current");
    jQuery(this).addClass("current");
    jQuery("#" + tab_id).addClass("current");
  });
}



// WEBPACK FOOTER //
// ./scripts/capabilities/script.js